module.exports = __webpack_public_path__ + "img/359.b106f671.jpg";